import { Icon } from '@/components/Icon'

interface PlanDetailSummaryProps {
	planName: string
	beds: string
	baths: string
	sqftRange?: string
	urgencyMessage?: string
	specialMessage?: string
	className?: string
}

export function PlanDetailSummary ({
	planName,
	beds,
	baths,
	sqftRange,
	urgencyMessage,
	specialMessage,
	className = ''
}: PlanDetailSummaryProps) {
	return (
		<div className={`spaces-plan-summary spaces:flex spaces:flex-col spaces:gap-24 ${className}`}>
			<div className='spaces:flex spaces:flex-col spaces:gap-4'>
				<h2 className='spaces:text-18/24 spaces:font-strong spaces:text-content-1'>{planName}</h2>
				<div className='spaces-plan-summary-attributes spaces:flex spaces:items-center spaces:gap-16 spaces:divide-x spaces:divide-canvas-3'>
					<div className='spaces:flex spaces:items-center spaces:gap-4 spaces:pr-16'>
						<Icon name='Bed' size={24} className='spaces:text-content-4' />
						<span className='spaces:text-16/24 spaces:font-default spaces:text-content-2'>{beds}</span>
					</div>
					<div className='spaces:flex spaces:items-center spaces:gap-4 spaces:pr-16'>
						<Icon name='Bath' size={24} className='spaces:text-content-4' />
						<span className='spaces:text-16/24 spaces:font-default spaces:text-content-2'>{baths}</span>
					</div>
					{sqftRange && (
						<div className='spaces:flex spaces:items-center spaces:gap-4'>
							<Icon name='Area' size={24} className='spaces:text-content-4' />
							<span className='spaces:text-16/24 spaces:font-default spaces:text-content-2'>
								{sqftRange} ft<sup className='spaces:text-10 spaces:font-strong'>2</sup>
							</span>
						</div>
					)}
				</div>
			</div>
			<div className='spaces-plan-summary-messages spaces:flex spaces:flex-col spaces:gap-8'>
				{urgencyMessage && (
					<div className='spaces-plan-urgency spaces:flex spaces:items-center spaces:gap-8 spaces:pl-12 spaces:pr-8 spaces:py-8 spaces:rounded-16 spaces:bg-warning-subtle spaces:text-warning-on-subtle'>
						<Icon name='Clock' size={24} />
						<span className='spaces:text-16/24 spaces:font-default'>{urgencyMessage}</span>
					</div>
				)}
				{specialMessage && (
					<div className='spaces:flex spaces:items-center spaces:gap-8 spaces:pl-12 spaces:pr-8 spaces:py-8 spaces:rounded-16 spaces:bg-success-subtle spaces:text-success-on-subtle'>
						<Icon name='Tag' size={24} />
						<span className='spaces:text-16/24 spaces:font-default'>{specialMessage}</span>
					</div>
				)}
			</div>
		</div>
	)
}
